import { render } from "./amendment.vue?vue&type=template&id=4304f3a5&scoped=true"
import script from "./amendment.vue?vue&type=script&lang=js"
export * from "./amendment.vue?vue&type=script&lang=js"

import "./amendment.vue?vue&type=style&index=0&id=4304f3a5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4304f3a5"]])

export default __exports__